import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../auth/UserContext.js";
import { Icon } from "../../components/Icon.js";
import { GoalCard } from "../../components/GoalCard.js";
import { NewGoalModal } from "../../components/NewGoalModal.js";
import { createGoal, type CreateGoalBody } from "../../api/goals.js";
import type { KidBundle } from "../../api/me.js";

export default function Goals() {
  const { bundle, refresh } = useUser();
  const navigate = useNavigate();
  const [showNew, setShowNew] = useState(false);

  if (!bundle || bundle.user.role !== "kid") return null;
  const kid = bundle as KidBundle;

  const onCreate = async (body: CreateGoalBody) => {
    await createGoal(kid.user.rowKey, body);
    await refresh();
    setShowNew(false);
  };

  return (
    <div>
      <div className="row-between" style={{ marginBottom: 24 }}>
        <div>
          <h1>Your goals</h1>
          <p className="soft" style={{ marginTop: 6 }}>
            Save up for the things you&apos;re excited about.
          </p>
        </div>
        <button className="btn btn-primary" onClick={() => setShowNew(true)}>
          <Icon name="plus" size={16} /> New goal
        </button>
      </div>

      <div className="grid grid-2">
        {kid.goals.map((g) => (
          <GoalCard
            key={g.rowKey}
            goal={g}
            kid={kid.user}
            account={kid.account}
            onClick={() => navigate(`/kid/goals/${g.rowKey}`)}
          />
        ))}
      </div>

      {showNew && (
        <NewGoalModal kid={kid.user} onClose={() => setShowNew(false)} onCreate={onCreate} />
      )}
    </div>
  );
}
